$(->
  $('.formtastic.goal_set select.question_type').change(->
    # these "magic numbers" are indexes of Question::TYPE for money, decimal and percentage
    if parseInt($(this).val()) in [10,21,22]
      $(this).closest('fieldset').find('.target_goal').show()
    else
      $(this).closest('fieldset').find('.target_goal').hide().find('input').val('')
  ).change()

  $('#js-employee-index select.app_question_set').change(->
    $.ajax({
      url: '/manage/employees/' + $(this).data('employee') + '/question_sets/' + $(this).val() + '.json',
      type: 'PATCH'
    })
  ).change()
)
